export default __webpack_public_path__ + "static/media/product-image-hover-6.7482d477.jpg";